<template>
  <zen-one 
  :showuserinfo="false" 
  title="Pentadbiran"
  :crumbs="crumbs"
  >
  <z-page
  title="Tadbir Kebenaran"
  >

  <w-dialog
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
      <w-icon class="mr2">fal fa-cog</w-icon>
      Sunting
    </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
      @validate="submit"
      @success="success"
    >
    <!-- <z-lookup 
      label="Modul"
      name="module"
      url="administration.modulelookup"
      :sort="false"
      :cache="false"
      
      v-model="form.module_id"
    /> -->
    <z-input label="Nama Kebenaran" v-model="form.display_name" name="name" :validators="[validators.required]" />
    
    </w-form>

    
    <template #actions>
      <div class="spacer" />
      <w-button bg-color="grey-light5--bg" @click="dialog.show = false">Tutup</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      :disabled="dialog.valid === false"
      @click="$refs.form.validate()"
      >
        Simpan
      </w-button>
    </template>

    
  </w-dialog>

  
  <z-table
    ref="tbluser"
    title="Senarai Kebenaran"
    :headers="table.headers"
    :items="table.items"
    :meta="table.meta"
    class="white--bg"
  >

    <template #button>
      <w-button 
      dark
      class="indigo-dark2--bg ml1" 
      @click="newrecord()"
      >
        <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
      </w-button>
    </template>
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>

    </template>

    <template #item-cell.icon="{ item, label, header, index }">
      <w-icon md class="mr1" >{{ item.icon }}</w-icon>
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="bs fs-2" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> Kemaskini
        </w-button>
        &nbsp;  
        <w-button class="fs-2" bg-color="red-light1" dark tile @click="destroy(item)">
          <w-icon xs class="mr2">fal fa-trash</w-icon> Padam
        </w-button>
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    menu: [Array, Object],
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'administration.permission',
      reload: true,
      crumbs: [
        { label: this.$page.props.app_name, route: '/sitemap' },
        { label: 'Pentadbiran', route: '/administration' },
        { label: 'Kebenaran', route: '/administration/permission' }
      ],
      form: {
        id: 0,
        module_id: 0,
        display_name: '',
      }
    }
  },
  methods: {

  },
  watch: {
    
  },
  mounted() {
    // override default setting
    this.dialog.width = 500
      
  },
}
</script>